import React, { useMemo } from 'react';
import { IconButton, Badge } from '@mui/material';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { useChatList } from './ChatListContext';
import { useUnreadCountsContext } from 'components/UnreadCountsContext';

const ChatIconButton: React.FC = () => {
  const { toggleChatList, isChatListVisible } = useChatList();
  const { unreadCounts } = useUnreadCountsContext();

  // Calculate total unread count from all conversations
  const totalUnreadCount = useMemo(() => {
    return Object.values(unreadCounts).reduce((sum, count) => sum + count, 0);
  }, [unreadCounts]);

  return (
    <IconButton
      onClick={toggleChatList}
      className="mx-2"
      sx={{
        color: '#fff',
        backgroundColor: '#3E73F0',
        marginRight: '12px',
        '&:hover': {
          backgroundColor: '#2A5CD0',
        },
        borderRadius: '999px',
        width: 36,
        height: 36,
        transition: 'background-color 0.15s ease-in-out',
        boxShadow: isChatListVisible ? '0 0 0 3px #D6E4FD' : 'none',
        border: 0,
      }}
      title="Messages"
    >
      <Badge 
        badgeContent={totalUnreadCount} 
        color="error" 
        invisible={totalUnreadCount === 0}
        sx={{
          '& .MuiBadge-badge': {
            fontSize: '0.65rem',
            fontWeight: 'bold',
            minWidth: '16px',
            height: '16px',
            padding: 0,
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            border: '2px solid #F5F7FF',
            top: 4,
            right: 4,
          },
        }}
      >
        <ChatBubbleIcon sx={{ fontSize: 20 }} />
      </Badge>
    </IconButton>
  );
};

export default ChatIconButton;

